var _path, _path2, _path3, _path4, _path5;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgClean({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.8576 24.1187L16.5536 30.3724C16.4858 30.5565 16.3631 30.7153 16.2022 30.8276C16.0413 30.9398 15.8498 30.9999 15.6536 30.9999C15.4574 30.9999 15.2659 30.9398 15.105 30.8276C14.9441 30.7153 14.8214 30.5565 14.7536 30.3724L12.4496 24.1187C12.4016 23.9885 12.326 23.8703 12.2278 23.7721C12.1297 23.674 12.0114 23.5983 11.8812 23.5503L5.62756 21.2464C5.44347 21.1785 5.2846 21.0559 5.17238 20.8949C5.06017 20.734 5 20.5425 5 20.3463C5 20.1502 5.06017 19.9587 5.17238 19.7977C5.2846 19.6368 5.44347 19.5142 5.62756 19.4463L11.8812 17.1424C12.0114 17.0944 12.1297 17.0187 12.2278 16.9206C12.326 16.8224 12.4016 16.7042 12.4496 16.5739L14.7536 10.3203C14.8214 10.1362 14.9441 9.97735 15.105 9.86514C15.2659 9.75292 15.4574 9.69276 15.6536 9.69276C15.8498 9.69276 16.0413 9.75292 16.2022 9.86514C16.3631 9.97735 16.4858 10.1362 16.5536 10.3203L18.8576 16.5739C18.9055 16.7042 18.9812 16.8224 19.0794 16.9206C19.1775 17.0187 19.2958 17.0944 19.426 17.1424L25.6796 19.4463C25.8637 19.5142 26.0226 19.6368 26.1348 19.7977C26.247 19.9587 26.3072 20.1502 26.3072 20.3463C26.3072 20.5425 26.247 20.734 26.1348 20.8949C26.0226 21.0559 25.8637 21.1785 25.6796 21.2464L19.426 23.5503C19.2958 23.5983 19.1775 23.674 19.0794 23.7721C18.9812 23.8703 18.9055 23.9885 18.8576 24.1187V24.1187Z",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.3268 5V10.7549",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M26.2043 7.87744H20.4494",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M29.0817 11.714V15.5506",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M31 13.6323H27.1634",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClean);
export default __webpack_public_path__ + "static/media/clean.705970cb.svg";
export { ForwardRef as ReactComponent };